import React from 'react';
import './radio-field.scss';
import { Beta } from '../../beta/beta';
import { TOOLTIP_TYPES, DxTooltipQuestion } from '../../dx-tooltip-question/dx-tooltip-question';
export const RadioField = ({ options, value, name, onChange }) => {
    return (<div className="form-radio-field">
      {options.map((option) => (<div className="form-radio-field__option" key={option.value}>
            <label className="form-radio-field__option-label" data-test-id={option.label}>
              {option.label}
              <input className="form-radio-field__option-input" type="radio" name={name} value={option.value} onChange={() => onChange(option.value)} checked={option.value === value}/>
              <span className="form-radio-field__checkmark"></span>
            </label>
            {option.beta ? <span className="form-radio-field__flag-beta"><Beta /></span> : null}
            {option.infoLabel ? <span className="form-radio-field__flag-tooltip" data-test-id="medical-device-tooltip">
                <DxTooltipQuestion type={TOOLTIP_TYPES.RIGHT} tooltipText={option.infoLabel}></DxTooltipQuestion>
            </span> : null}
           </div>))}
    </div>);
};
